export default __webpack_public_path__ + "static/media/delete-red-bin.2ee194b3.svg";